const CART_EVENTS_TYPES = {
  1: 'Reco_MenuPage_PreviousItem_Added',
  2: 'Reco_MenuPage_Bestseller_Added',
  3: 'Reco_CartPage_Recommendations_Added',
  4: 'Reco_MenuPage_FrequentlyAddedItems_Added',
};

export const recsEventsTrack = (hitNameType, data) => {
  const hitName = CART_EVENTS_TYPES[hitNameType];
  if (!data) return;
  try {
    window.__bgtracker.track(hitName, {
      hitName,
      ...data,
    });
  } catch (error) {
    console.log(error);
  }
};
